module.exports = __webpack_public_path__ + "img/wenlv.fbfe2e26.png";